/**
 * Reveals the next `data-page-size` hidden cards in `.blog-grid`.
 * All articles are rendered server-side (globally sorted), so no fetching is needed.
 */
class BlogLoadMore extends HTMLElement {
  constructor() {
    super();
    this.onLoadMore = this.handleLoadMore.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.onLoadMore);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onLoadMore);
  }

  handleLoadMore() {
    const pageSize = Number(this.dataset.pageSize) || 6;
    const hiddenCards = document.querySelectorAll('.blog-grid > .blog-card[hidden]');

    for (const card of Array.from(hiddenCards).slice(0, pageSize)) {
      card.hidden = false;
    }

    if (hiddenCards.length <= pageSize) {
      this.closest('.blog-footer')?.remove() ?? this.remove();
    }
  }
}

if (!customElements.get('blog-load-more')) {
  customElements.define('blog-load-more', BlogLoadMore);
}
